import { ele } from "cables-shared-client";
import web from "../../index.js";
import api from "../../api.js";

export default class PageActivityFeed
{
    constructor(targetElement)
    {
        this._webpush = {
            "WEBPUSH_WORKER": "/webpush_worker.js",
            "publicKey": targetElement.dataset.webpushkey,
            "forceHideRegisterButton": targetElement.dataset.forcehideregisterbutton
        };

        document.addEventListener("visibilitychange", (event) =>
        {
            if (document.visibilityState === "visible")
            {
                this.displayMyFeed(ele.byId("activityFeed"), false);
            }
        });
    }

    displayMyFeed(targetEl, fromUserInteraction)
    {
        const feedTarget = targetEl || ele.byId("activityFeed");
        api.get("activityfeed/myfeed?pushConfig=true", (result) =>
        {
            const data = result.data;
            const entries = data.entries;
            const serverSubscriptions = data.webpushSubscriptions;

            web.getServiceWorkerSubscription(this._webpush.WEBPUSH_WORKER, (err, sub) =>
            {
                let showRegisterButton = false;
                if (!err)
                {
                    if (sub)
                    {
                        if (serverSubscriptions && !serverSubscriptions.find((ws) => { return ws.deviceId === sub.endpoint; }))
                        {
                            if (!this._webpush.forceHideRegisterButton) showRegisterButton = true;
                            // cleanup orphaned subscription deleted on other device
                            web.unregisterWebPushWorker(this._webpush.WEBPUSH_WORKER);
                        }
                    }
                    else
                    {
                        if (window.Notification && window.Notification.permission === "denied")
                        {
                            if (!this._webpush.forceHideRegisterButton) showRegisterButton = false;
                        }
                        else
                        {
                            if (!this._webpush.forceHideRegisterButton) showRegisterButton = true;
                        }
                    }
                }

                for (let i = 0; i < entries.length; i++)
                {
                    const entry = entries[i];
                    if (entry.displayActions && entry.displayActions.length > 3)
                    {
                        const allActions = entry.displayActions;
                        const buttons = allActions.slice(0, 3);
                        const menuItems = allActions.slice(3);
                        entry.displayActions = buttons;
                        entry.menuItems = menuItems;
                    }
                    entry.thumbFormat = "projectThumb";
                    if (["TeamInvite", "Membership"].includes(entry.topic)) entry.thumbFormat = "team-container";
                }

                if (feedTarget)
                {
                    web.setHandleBarHtml("activityfeed", {
                        "entries": entries,
                        "retentionDate": data.retentionDate,
                        "showRegisterButton": showRegisterButton,
                        "count": entries.length,
                        "states": data.states
                    }, feedTarget);

                    const allFilters = feedTarget.querySelectorAll(".filters .feedfilter");
                    allFilters.forEach((filter) =>
                    {
                        filter.addEventListener("click", () =>
                        {
                            const filterState = filter.dataset.filter;
                            allFilters.forEach((f) =>
                            {
                                f.classList.remove("active");
                            });
                            filter.classList.add("active");
                            feedTarget.querySelectorAll(".activityFeedEntry").forEach((item) =>
                            {
                                if (filterState === "all" || item.classList.contains(filterState))
                                {
                                    ele.show(item);
                                }
                                else
                                {
                                    ele.hide(item);
                                }
                            });
                        });
                    });

                    web.activityFeed.registerActionListeners(feedTarget);
                }
            });
        });
    }

    registerDevice(button)
    {
        const errorEle = ele.byId("adddevice-error");
        if (errorEle) ele.hide(errorEle);
        web.buttons.startSavingAnimButton(button);
        web.registerWebPushWorker(this._webpush.WEBPUSH_WORKER, this._webpush.publicKey, (err, sub) =>
        {
            if (!err)
            {
                web.buttons.stopSavingAnimButton(button);
                let body = [];
                ["PatchInvite", "TeamInvite", "Membership"].forEach((topic) =>
                {
                    let browserName = "Unknown Browser";
                    if (platform) browserName = platform.name + " (" + platform.os.family + ")";
                    const data = {
                        "topic": topic,
                        "channel": "webpush",
                        "scope": "all",
                        "deviceId": sub.endpoint,
                        "deviceName": browserName
                    };
                    data.subscriptionData = sub;
                    body.push(data);
                });
                api.patch("activityfeed/subscriptions", body, () =>
                {
                    if (button) ele.hide(button);
                });
            }
            else
            {
                web.buttons.stopSavingAnimButton(button, true, true);
                if (errorEle)
                {
                    const errorMsg = errorEle.querySelector(".msg");
                    errorMsg.innerText = err + ": " + sub;
                    ele.show(errorEle);
                    if (button) ele.hide(button);
                }
            }
        });
    }
}
